export default __webpack_public_path__ + "static/media/6 CCI_LOGO_H-B (2).40262f32.png";